export const PIPELINES = {
  CRO: { id: 1, name: "Phoenix", code: "cro" },
  SARSCOV2: { id: 2, name: "Cecret", code: " sars-cov-2" },
  CAURIS: { id: 3, name: "MycoSNP", code: "cauris" },
  PHYLO: { id: 4, name: "PhyloTree", code: "phylo" }

};

/**
 * Mainly Imported by JobForm Pages
 */
export const PIPELINE_CONFIG = [
  {
    id: 1,
    code: "cro",
    sideBarName: "CRO",
    data: "CRO",
    pipeline_n: "Phoenix",
    icon: "nc-icon nc-chart-pie-35",
    path: "/dashboard/cro",
    apiEndpoint: "/api/jobs/createcro",
  },
  {
    id: 2,
    code: "sars-cov-2",
    sideBarName: "SARS-CoV-2",
    data: "SARS-CoV-2",
    pipeline_n: "Cecret",
    icon: "nc-icon nc-chart-pie-35",
    path: "/dashboard/sars-cov-2",
    apiEndpoint: "/api/jobs/createsars",
  },
  {
    id: 3,
    code: "cauris",
    sideBarName: "C.auris",
    data:"C.auris",
    pipeline_n: "MycoSNP",
    icon: "nc-icon nc-chart-pie-35",
    path: "/dashboard/cauris",
    apiEndpoint: "/api/jobs/createcauris",
  },
  {
    id: 4,
    code: "phylo",
    sideBarName: "PhyloTree",
    data: "This analysis currently only supports C.auris data",
    pipeline_n: "PhyloTree",
    icon: "nc-icon nc-chart-pie-35",
    path: "/dashboard/phylo",
    apiEndpoint: "/api/jobs/createphylo",
  }
];


/**
 * 通过code获取流水线配置
 */
export const getPipelineByCode = (code) => {
  return PIPELINE_CONFIG.find(p => p.code === code);
};


// 默认导出所有工具
export default {

  getPipelineByCode,

};